type Input = {
  value: number
  valueCurrencyCode: string
  defaultCurrencyCode: string
  fxRatesByCode: Record<string, number>
}

export const convertToDefaultCurrency = ({
  value,
  valueCurrencyCode,
  defaultCurrencyCode,
  fxRatesByCode,
}: Input): number | null => {
  if (valueCurrencyCode === defaultCurrencyCode) return value

  const valueFxRate = fxRatesByCode[valueCurrencyCode]
  const defaultFxRate = fxRatesByCode[defaultCurrencyCode]

  if (valueFxRate == null || defaultFxRate == null) return null

  return Math.round(((value * defaultFxRate) / valueFxRate) * 100) / 100
}
